<template>
<form>
  <v-app>
    <v-container fluid grid-list-lg >
      <v-card>
        <v-toolbar card>
          <v-icon>domain</v-icon>
          <v-toolbar-title class="font-weight-light">Legajo de Persona Jurídica</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
          <v-layout wrap>
            <v-flex lg12 >
              <div class="subheading">Resumen</div>              
            </v-flex>

            <v-flex lg3>
              <v-card dark color="purple">
                <v-card-text>
                  <div class="caption">{{ model.apellido}}</div>
                  <div class="caption">CUIT:{{ model.cui}}</div>
                  <div class="caption">&nbsp;</div>
                </v-card-text>                
              </v-card>
            </v-flex>
            <v-flex lg3>
              <v-card dark color="green darken-3">
                <v-card-text>
                  <div class="caption">Email: {{ email}}</div>
                  <div class="caption">Celular: {{ numeroCelular }}</div>
                  <v-tooltip bottom>
                    <div class="caption" @click="gotoDatosContacto" slot="activator">+ datos</div>
                    <p>Ver Datos de Contacto</p>
                  </v-tooltip>  
                </v-card-text>
              </v-card>                
            </v-flex>

          </v-layout>
        </v-container>

        <v-card-text>
          <v-container fluid grid-list-lg >
            <v-layout   >
                <v-flex lg10 xl8>
                  <v-tabs
                    v-model="active"
                    color="orange"                  
                    slider-color="green"
                  >
                    <v-tab key="particulares" ripple >
                      Datos Particulares
                    </v-tab>
                    <v-tab key="contacto" ripple>
                      Datos de Contacto
                    </v-tab>

                    <v-tab-item key="particulares" >
                      <v-card text>
                        <datos-particulares :value="model"></datos-particulares>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="contacto" >
                      <v-card text>
                        <datos-contacto :value="model.datosContacto"></datos-contacto>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>

                </v-flex>               
            </v-layout>
          </v-container>
        </v-card-text>  
        <v-card-actions bottom>
          <v-speed-dial direction="right" >
            <v-btn slot="activator" color="orange" text small v-show="editMode">
              <v-icon color="orange">touch_app</v-icon>                                
              Mas Acciones
            </v-btn>
            <v-tooltip bottom>
              <v-btn small text color="green" slot="activator" @click="" v-show="editMode">
                Ver Cuenta Corriente
              </v-btn>
              <v-btn small text color="green" slot="activator" @click="" v-show="editMode">
                  <!-- <p v-if="model.status.baja">Re-Habilitar</p> -->
                  <p >Re-Habilitar</p>
                  <p >Dar de Baja</p>
              </v-btn>
            </v-tooltip>
          </v-speed-dial>
           
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!editMode" @click="saveItem" :loading="loading"><v-icon>save</v-icon>Guardar</v-btn>
        </v-card-actions>
      </v-card >
      
    </v-container>
    
  </v-app>
</form>
</template>

<script>
import DatosParticulares from './personaJuridicaParticulares'
import DatosContacto from './contacto'

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapMutations
} from 'vuex'

export default {
    props: ['personaId'],
    data () {
      return {
        active: null,
        loading: false,
        editMode: true,
        model: {domicilios:[]}
      }
    },
    components:{
    'datos-particulares': DatosParticulares,
    'datos-contacto': DatosContacto,    
  },
  async created() {    
    if(this.personaId)
      this.loadPersona(this.personaId);
  },
  computed:{
    numeroCelular: function(){
       if(this.model.datosContacto && this.model.datosContacto.telefonos){
         for (let index = 0; index < this.model.datosContacto.telefonos.length; index++) {
           const item = this.model.datosContacto.telefonos[index];
           if(item.esCelular){
             return item.numero;
           }           
         }
         return '(no cargado)';
       }
       else return ''
    },
    email: function(){
       if(this.model.datosContacto){
          if(this.model.datosContacto.email != '')
            return this.model.datosContacto.email;
          else
            return '(no cargado)';         
       }
       else return ''
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    async gotoDatosContacto(){
      this.active = 1
    },
    async loadPersona() {
        this.loading = true
        try {
            var result = await http.get('personas/' + this.personaId);
            
            this.model = result;

            // trato las fechas
            var dob = this.$moment(this.model.fechaNacimiento).format('YYYY-MM-DD') // Todo: ver qué pasa cuando graba
            this.model.fechaNacimiento = dob;

            this.model.tipoPersonaId = 2;

            Vue.$log.debug(this.model);
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async saveItem(){

      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0){
        Vue.$log.debug('validation:');
        Vue.$log.debug(this.errors);
        return;
      } 
      
      this.model.documento = this.model.cui.substring(2,10);

      try{          
          this.loading = true;
          if(this.model.id == "00000000-0000-0000-0000-000000000000"){
            var result = await http.post('personas', JSON.stringify( {persona:  this.model} ) );
            this.alertSuccess('Los cambios han sido guardados.')
          
            // recargo los datos
            this.loadPersona(result.entity.id);
          }
          else{
            var result2 = await http.put('personas', JSON.stringify( {persona:  this.model} ) );
            
            this.alertSuccess('Los cambios han sido guardados.')
            // recargo los datos
            this.loadPersona(result2.entity.id);
          }

        } 
        catch(error){
          // Error          
          this.alertError(error)
        } 
        this.loading = false;
    }
  }
}
</script>
